package xim.poc.game.configuration.v0.tactics

import xim.math.Vector3f
import xim.poc.EffectManager
import xim.poc.SceneManager
import xim.poc.ZoneAssociation
import xim.poc.audio.BackgroundMusicResponse
import xim.poc.game.ActorStateManager
import xim.poc.game.PlayerTargetSelector
import xim.poc.game.configuration.*
import xim.poc.game.configuration.v0.FloorEntity
import xim.poc.game.configuration.v0.GameV0
import xim.poc.game.configuration.v0.ZoneLogic
import xim.poc.tools.ZoneConfig
import kotlin.time.Duration.Companion.seconds

class TacticsZoneInstance: ZoneLogic {

    companion object {
        const val zoneId = 10
        val entryPosition = ZoneConfig(zoneId = zoneId, startPosition = Vector3f(x=290f,y=8f,z=286f))

        fun getCurrentMatch(): TacticsMatchInstance? {
            return GameV0.getCurrentTacticsZoneInstance()?.currentMatch
        }

    }

    private val entities = ArrayList<FloorEntity>()

    val portraitDummy: TacticsPortraitDummy
    var instinctRoller: TacticsInstinctRoller? = null

    private var currentMatch: TacticsMatchInstance? = null

    init {
        entities += TacticsBookEntity(this, location = Vector3f(x=280f,y=8f,z=293f))
        entities += TacticsExitNpc(location = Vector3f(x=290.02f,y=7.00f,z=280.00f))

        portraitDummy = TacticsPortraitDummy()
        entities += portraitDummy

        maybeSetupInstinctRoller()

        ActorStateManager.player().position.copyFrom(getEntryPosition().startPosition!!)

        SceneManager.getCurrentScene().getMainArea().runEffectRoutine("effe/evig/s3ch")
    }

    override fun update(elapsedFrames: Float) {
        entities.forEach { it.update(elapsedFrames) }

        val player = ActorStateManager.player()
        if (player.position.z > 293.5f) { player.position.z = 293.5f }

        val current = currentMatch ?: return
        ActorStateManager.player().targetable = false

        current.update(elapsedFrames)
        if (!current.readyToExit()) { return }

        runCleanUpScript(current)
    }

    override fun getGameSpeedOverride(): Float? {
        return currentMatch?.getGameSpeed()
    }

    override fun cleanUp() {
        ActorStateManager.player().targetable = true
        entities.forEach { it.cleanup() }
        portraitDummy.cleanup()
    }

    override fun getEntryPosition(): ZoneConfig {
        return entryPosition
    }

    override fun toNew(): ZoneLogic {
        return TacticsZoneInstance()
    }

    override fun getMusic(): BackgroundMusicResponse? {
        return currentMatch?.getMusic()
    }

    override fun drawUi() {
        currentMatch?.arenaUi?.drawGauges()
    }

    fun getMatch(): TacticsMatchInstance? {
        return currentMatch
    }

    fun setMatch(matchInstance: TacticsMatchInstance) {
        PlayerTargetSelector.clearTarget()
        currentMatch = matchInstance

        instinctRoller?.cleanup()
        instinctRoller = null
    }

    private fun maybeSetupInstinctRoller() {
        if (instinctRoller != null || !TacticsState.hasClearedChallenge(tacticsChallenge_AncientVows)) { return }
        instinctRoller = TacticsInstinctRoller()
    }

    private fun runCleanUpScript(current: TacticsMatchInstance) {
        if (EventScriptRunner.isRunningScript()) { return }

        EventScriptRunner.runScript(EventScript(listOf(
            FadeOutEvent(0.25.seconds),
            WaitRoutine(0.20.seconds),
            TacticsUnloadSubAreaEvent(SceneManager.getCurrentScene()),
            TacticsPillarToggle(show = true),
            RunOnceEventItem {
                ActorStateManager.player().targetable = true

                current.cleanUp()
                currentMatch = null

                val mainArea = SceneManager.getCurrentScene().getMainArea()
                EffectManager.clearEffects(ZoneAssociation(mainArea))
                mainArea.registerEffects()

                portraitDummy.reset()
                maybeSetupInstinctRoller()
            },
            FadeInEvent(0.25.seconds),
        )))
    }

}